<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Input from 'dashboard/components-next/input/Input.vue';

const emit = defineEmits(['send']);
const { t } = useI18n();
const dialogRef = ref(null);
const phoneNumber = ref('');
const isLoading = ref(false);

const open = () => dialogRef.value.open();
const close = () => dialogRef.value.close();
const confirm = async () => {
  if (!phoneNumber.value.trim()) return;
  isLoading.value = true;
  try {
    await new Promise((resolve, reject) => {
      emit('send', phoneNumber.value.trim(), resolve, reject);
    });
    close();
  } catch {
    // the parent shows the error toast
  } finally {
    isLoading.value = false;
  }
};
defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    :title="t('WASAPI_CAMPAIGNS.TEST.TITLE')"
    :description="t('WASAPI_CAMPAIGNS.TEST.DESCRIPTION')"
    :confirm-button-label="t('WASAPI_CAMPAIGNS.TEST.SEND')"
    :cancel-button-label="t('WASAPI_CAMPAIGNS.CONFIRM.CANCEL')"
    :is-loading="isLoading"
    :disable-confirm-button="!phoneNumber.trim()"
    @confirm="confirm"
  >
    <Input
      v-model="phoneNumber"
      type="tel"
      :label="t('WASAPI_CAMPAIGNS.TEST.PHONE_LABEL')"
      :placeholder="t('WASAPI_CAMPAIGNS.TEST.PHONE_PLACEHOLDER')"
      @keydown.enter.prevent.stop="confirm"
    />
  </Dialog>
</template>
